import React from 'react';

interface PageContainerProps {
    children: React.ReactNode;
    className?: string;
}

export function PageContainer({ children, className }: PageContainerProps) {
    return (
        <div className={`space-y-2 md:space-y-2 ${className || ''}`} style={{ position: "relative" }}>
            {children}
        </div>
    );
}
